import type { I18nLocale } from '@ardoq/i18n';
import { getRelationshipsViewLegendContents } from 'tabview/relationshipDiagrams/utils';
import type { Points3DLegendData } from './sourceData/buildPoints3DSourceData';

export type Points3DLegendRows = ReturnType<
  typeof getRelationshipsViewLegendContents
>;

/**
 * Swatches on, shapes off: every component is drawn as a disc, so a legend offering shapes would
 * describe a distinction the picture does not make.
 */
export const toPoints3DLegendRows = (
  { componentTypes, activeConditionalFormatting }: Points3DLegendData,
  i18nLocale: I18nLocale
): Points3DLegendRows =>
  getRelationshipsViewLegendContents({
    componentTypes,
    referenceTypes: [],
    selectedComponentTypes: [],
    selectedReferenceTypes: [],
    selectedConditionalFormattingIds: [],
    hasCollapsedNodes: false,
    hasNonComponentNodes: false,
    hasReferenceParents: false,
    isUserDefinedGrouping: false,
    showComponentSwatches: true,
    showComponentShapes: false,
    showReferencesAsLines: false,
    selectableItems: false,
    isNewConditionalFormatting: true,
    activeConditionalFormattingForLegend: activeConditionalFormatting,
    i18nLocale,
  });
